import withWorkstationPhoneId from '../../hoc/withWorkstationPhoneId';
import PhoneListItem from './PhoneListItem';

export default withWorkstationPhoneId(PhoneListItem);
